import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { AppSettingsService } from 't4-app-integration';
import { ActiveRentalService, LayoutService } from 'app-components';


@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css'],
  standalone: false
})
export class ChatbotComponent implements OnInit {
  zendeskKey = 'fa045ccb-5bab-4193-bff5-7ec511bf2836';
  lang = 'sv';
  private zendeskReady?: Promise<void>;
  constructor(private renderer: Renderer2, public appSettings: AppSettingsService, private layout: LayoutService, private activeRentalService: ActiveRentalService) { }

  ngOnInit(): void {
    if (this.appSettings.appType == 'app') {
      setTimeout(() => {
        if(this.appSettings.contextId.toLowerCase() == 'kanleiesunmanned_api') this.loadZendeskScript();
        if (this.appSettings.contextId.toLowerCase() == '24rentalunmanned_api') this.loadAmidra();
      }, 100);
    }
  }

  loadZendeskScript(): void {
    if (document.getElementById('ze-snippet')) {
      this.hideLauncher();      
    }
    
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'ze-snippet';
    script.charset = 'utf-8';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${this.zendeskKey}`;
    script.onload = () => {
      (window as any).zE("messenger:set", 'locale', this.appSettings.language);
      this.hideLauncher();
    };

    script.onerror = (error) => { console.error('Error loading the zendesk script:', error); };

    this.renderer.appendChild(document.head, script);
  }

  private hideLauncher() {
    this.onReady(() => {
      try { (window as any).zE('messenger', 'hide'); } catch { }
    });
  }

  private onReady(fn: () => void) {
    (this.zendeskReady ?? Promise.resolve()).then(fn);
  }

  public openChat() {
    (window as any).AmidraChat('open');

    this.onReady(() => {
      (window as any).zE('messenger', 'show');
      (window as any).zE('messenger', 'open');
      (window as any).zE('messenger:on', 'close', () => {
        (window as any).zE('messenger', 'hide');
      });
    });
  }

  loadAmidra(): void {
    if (document.getElementById('amidra-chat-bootstrap')) {
      this.hideLauncher();
    }

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'amidra-chat-bootstrap';
    script.charset = 'utf-8';
    script.src = `https://chat.amidra.se/amidra-chat.bootstrap.js`;
    script.setAttribute('data-amidra', 'eyJUZW5hbnRJZCI6ImJyZW5kZXJ1cC1yZW50YWwiLCJCcmFuZElkIjozfQ==');

    script.onload = () => {
      (window as any).AmidraChat("set", "showLauncher", false);

      (window as any).AmidraChat("on", "clientTool.openSwapTrailerUI", (params: any) => {
        if (params.bookingId) {
          this.activeRentalService.navigateToSwapTrailer(parseInt(params.bookingId));
          setTimeout(() => (window as any).AmidraChat('close'), 3000);
        }
      });

      if (this.appSettings.userLoggedIn && this.appSettings.customer?.Email) {
        (window as any).AmidraChat('identify', { email: this.appSettings.customer.Email });
      }
    };

    script.onerror = (error) => { console.error('Error loading the zendesk script:', error); };

    this.renderer.appendChild(document.head, script);
  }


}
